<template>
  <div>
    <div class="wrapper flex flex-between">
      <div>
        <breadcrumb :crumbs="[$t('menu.notices')]"></breadcrumb>
      </div>
      <div class="page-tabs">
        <router-link to="/normal/messages/receive" class="active">{{
          $t("menu.noticesReceived")
        }}</router-link>
        <el-divider direction="vertical"></el-divider>
        <router-link to="/normal/messages/send">{{
          $t("menu.noticesSend")
        }}</router-link>
      </div>
      <div>
        <!-- 占位 -->
      </div>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.content"
            :placeholder="$t('notice.content')"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.senderName"
            :placeholder="$t('notice.sender')"
          />
        </el-form-item>
        <el-form-item>
          <date-range
            size="small"
            v-model="searchForm"
            type="datetime"
            field="sendAt"
            :start-placeholder="
              this.$t('rules.startAt', [this.$t('notice.sendAt')])
            "
            :end-placeholder="
              this.$t('rules.endAt', [this.$t('notice.sendAt')])
            "
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button
              type="success"
              size="mini"
              :loading="readBatchDoing"
              @click="readBatch"
              >{{ $t("notice.readBatch") }}</el-button
            >
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        :loading="loading"
        id="workerTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column field="type" :title="$t('text.type')" min-width="100">
          <template v-slot="{ row }">
            <span v-if="!['sup2CusMes', 'cus2SupMes'].includes(row.type)">
              {{ $t("noticeTypes." + row.type) }}
            </span>
            <span v-if="row.type == 'sup2CusMes'">供应商发给我的</span>
            <span v-if="row.type == 'cus2SupMes'">客户发给我的</span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('notice.serialNo')"
          min-width="160"
        >
          <template v-slot="{ row }">
            <span v-if="row.type != null">
              <span
                v-if="!['sys'].includes(row.type)"
                class="blue"
                @click="showRow(row)"
              >
                {{ row.serialNo }}
              </span>
              <span v-else>{{ row.serialNo }}</span>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="content"
          :title="$t('notice.content')"
          min-width="400"
        >
          <template v-slot="{ row }">
            <raw-html :content="row.content" type="richText" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="senderName"
          :title="$t('notice.sender')"
          min-width="100px"
        />
        <vxe-table-column
          field="sendAt"
          :title="$t('notice.sendAt')"
          min-width="110px"
        />
        <vxe-table-column
          field="readAt"
          :title="$t('notice.readAt')"
          min-width="110px"
        />
        <vxe-table-column field="action" :title="$t('text.action')" width="50">
          <template v-slot="{ row }">
            <el-button
              v-if="row.readAt == null"
              type="text"
              size="mini"
              @click="read(row)"
              >{{ $t("notice.readed") }}</el-button
            >
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips"></div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <drawer
      :title="$t('text.view')"
      :visible.sync="showDF"
      size="900px"
      direction="rtl"
      :wrapper-closable="false"
      :destroy-on-close="true"
    >
      <show-order
        :uuid="rowUuid"
        v-if="
          (rowEntity == 'Purchase' && ['cus2SupMes'].includes(rowType)) ||
          (rowEntity == 'Order' && !['sup2CusMes'].includes(rowType))
        "
      />
      <show-purchase
        :uuid="rowUuid"
        v-if="
          (rowEntity == 'Order' && ['sup2CusMes'].includes(rowType)) ||
          (rowEntity == 'Purchase' && !['cus2SupMes'].includes(rowType))
        "
      />
    </drawer>
  </div>
</template>

<script>
import { page, table } from "@/utils/mixins.js";
import DateRange from "@/components/DateRange";
import RawHtml from "@/components/RawHtml";
import Notice from "@/api/notice.js";
import ShowOrder from "./showOrder";
import ShowPurchase from "./showPurchase";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.sorter,
    table.basic,
  ],
  components: { DateRange, RawHtml, ShowOrder, ShowPurchase },
  data() {
    return {
      narrows: [
        [
          {
            label: this.$t("notice.readInfo"),
            items: [
              {
                label: this.$t("notice.readed"),
                key: "yes",
                condition: { read: "yes" },
              },
              {
                label: this.$t("notice.unRead"),
                key: "no",
                condition: { read: "no" },
              },
            ],
          },
        ],
      ],
      initFilter: "no",
      searchForm: {
        content: null,
        senderName: null,
        sendAtStartAt: null,
        sendAtEndAt: null,
      },

      readBatchDoing: false,

      rowEntity: null,
      rowType: null,
      rowUuid: null,
      showDF: false,
    };
  },
  methods: {
    //=========
    showRow(row) {
      this.rowEntity = row.entity;
      this.rowType = row.type;
      this.rowUuid = row.uuid;
      this.showDF = true;
    },

    readBatch() {
      const self = this;
      self.readBatchDoing = true;
      Notice.allRead().then(function (res) {
        self.readBatchDoing = false;
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.readSuccess"),
            type: "success",
          });
          self.loadData();
          self.unreadQty();
        } else {
          self.sysError();
        }
      });
    },
    read(row) {
      const self = this;
      Notice.read(row.id).then(function (res) {
        if (res.status === 200) {
          self.$message({
            message: self.$t("prompt.readSuccess"),
            type: "success",
          });
          self.loadData();
          self.unreadQty();
        } else {
          self.sysError();
        }
      });
    },
    unreadQty() {
      const self = this;
      Notice.unreadQty().then(function (res) {
        if (res.status == 200) {
          if (res.data == 0) {
            self.$eventHub.$emit("noticeReadFinish");
          }
        } else {
          self.sysError();
        }
      });
    },
    //
    dataProvider(params) {
      return Notice.searchReceived(params);
    },
  },
};
</script>

<style scoped>
</style>